import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import * as _ from 'lodash';
import { FiArrowDown, FiArrowUp } from 'react-icons/fi';
import moment from 'moment';
import { searchPolicy } from '../../actions/policy';
import { convertUtcToLocalTime } from '../../helper';
import DownloadPolicyBtn from './DownloadPolicyBtn';

export const ReportPolicyListData = ({ onMount, values }) => {
  const [rows, setRows] = useState([]);
  const [itemPerPage, setItemPerPage] = useState(20);
  const [page, setPage] = useState(values || []);
  const [pageCount, setPageCount] = useState(1);
  const [pageIndex, setPageIndex] = useState(1);
  const [sort, setSort] = useState();

  const dispatch = useDispatch();

  const length = (values || []).length;

  const renderBack = () => {
    return pageIndex <= 1 ? null : (
      <a
        className='text-primary'
        onClick={() => {
          const prevPage = pageIndex - 1;
          if (prevPage > 0) {
            const pages = rows?.slice(prevPage * itemPerPage, pageIndex * itemPerPage);
            setPage(pages);
            setPageIndex(prevPage);
          }
        }}
        role='button'
      >
        {'<< '}Trước
      </a>
    );
  };

  const renderNext = () => {
    return pageIndex >= pageCount ? null : (
      <a
        className='text-primary'
        onClick={() => {
          const nextPage = pageIndex + 1;
          if (nextPage <= pageCount) {
            const row = rows?.slice(pageIndex * itemPerPage, nextPage * itemPerPage);
            setPage(row);
            setPageIndex(nextPage);
          }
        }}
        role='button'
      >
        Sau {' >>'}
      </a>
    );
  };

  const renderPageIndex = () => {
    if (pageCount <= 1) return null;
    return (
      <span>
        Trang {pageIndex} / {pageCount}
      </span>
    );
  };

  const renderItemPerPage = () => {
    return (
      <div className='input-group'>
        <label className='input-group-text bg-white border-0 font-weight-bold'>Số hàng mỗi trang</label>
        <select value={itemPerPage} onChange={(e) => setItemPerPage(e.target.value)} className='form-control'>
          <option>5</option>
          <option>10</option>
          <option>20</option>
          <option>50</option>
          <option>100</option>
        </select>
      </div>
    );
  };

  const renderPaging = () => {
    return (
      <div className='d-flex justify-content-between align-items-center'>
        <div>{renderBack()}</div>
        <div>{renderItemPerPage()}</div>
        <div>{renderPageIndex()}</div>
        <div>{renderNext()}</div>
      </div>
    );
  };

  useEffect(() => setRows(values), [values]);

  useEffect(() => {
    onMount();
  }, [onMount]);

  useEffect(() => {
    let page = (rows || []).slice(0, itemPerPage);
    setPage(page);
    setPageIndex(1);
    setPageCount(Math.ceil((rows || []).length / itemPerPage));
  }, [rows, itemPerPage]);

  useEffect(() => {
    const key = _.keys(sort)[0];
    const value = sort?.[key];
    if (value) {
      let newRows;
      if (['policyissuedt', 'premiumduedate'].includes(key)) {
        newRows = rows?.sort((first, second) => {
          if (!first || !first[key] || !second || !second[key]) return 1;
          let d1 = moment(first?.[key], 'DD/MM/YYYY');
          let d2 = moment(second?.[key], 'DD/MM/YYYY');
          return !d1.isValid() ? 1 : !d2.isValid() ? 1 : d1.format('YYYYMMDD') - d2.format('YYYYMMDD');
        });
      } else {
        newRows = _.sortBy(rows, [key]);
      }

      if (value === 'desc') newRows = _.reverse(newRows);
      setRows(newRows);
    }
  }, [sort]);

  const onSubmit = async (values, helper) => {
    helper.setSubmitting(true);
    try {
      helper.setSubmitting(false);
      dispatch(searchPolicy());
    } catch (error) {
      helper.setSubmitting(false);
      alert('Không thể thực hiện yêu cầu');
    }
  };

  const toggleSort = (name) => {
    let value = sort?.[name] || '';
    if (value === 'asc') value = 'desc';
    else if (value === 'desc') value = 'asc';
    else value = 'asc';
    setSort({ [name]: value });
  };

  const initialValues = {
    bankStaffCode: '',
    seqList: [],
  };

  const validationSchema = Yup.object().shape({
    bankStaffCode: Yup.string().required('Chọn từ danh sách'),
    seqList: Yup.array().min(1, 'Chọn ít nhất 1 lead từ danh sách'),
  });

  const renderArrow = (name) => {
    return <> {sort?.[name] === 'asc' ? <FiArrowUp /> : sort?.[name] === 'desc' ? <FiArrowDown /> : null}</>;
  };

  const renderTable = () => (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
      enableReinitialize={true}
    >
      {(props) => (
        <Form>
          <div>
            <span>
              Tìm thấy <b>{length}</b> kết quả
            </span>
            {/* {length === 0 ? null : (
              <div className='d-inline-block float-right mb-1'>
                <DownloadPolicyBtn />
              </div>
            )} */}
          </div>

          <table className='table'>
            <thead>
              <tr className='bg-secondary text-white'>
                <th className='align-top' onClick={() => toggleSort('policynum')}>
                  <span>Số hợp đồng</span>
                  {renderArrow('policynum')}
                </th>
                <th className='align-top' onClick={() => toggleSort('policyissuedt')}>
                  <span>Ngày phát hành</span>
                  {renderArrow('policyissuedt')}
                </th>
                <th className='align-top' onClick={() => toggleSort('baseproductname')}>
                  <span>Sản phẩm</span>
                  {renderArrow('baseproductname')}
                </th>
                <th className='align-top text-right' onClick={() => toggleSort('premiumdueamount')}>
                  <span>Phí BH đến hạn</span>
                  {renderArrow('premiumdueamount')}
                </th>
                <th className='align-top' onClick={() => toggleSort('premiumduedate')}>
                  <span>Ngày đến hạn đóng phí</span>
                  {renderArrow('premiumduedate')}
                </th>
                <th className='align-top' onClick={() => toggleSort('poname')}>
                  <span>Họ tên BMBH</span>
                  {renderArrow('poname')}
                </th>
                <th className='align-top' onClick={() => toggleSort('pomobile')}>
                  <span>Điện thoại</span>
                  {renderArrow('pomobile')}
                </th>
                <th className='align-top' onClick={() => toggleSort('poemail')}>
                  <span>Email</span>
                  {renderArrow('poemail')}
                </th>
                <th className='align-top' onClick={() => toggleSort('poidentifynum')}>
                  <span>Số CMND/CCCD</span>
                  {renderArrow('poidentifynum')}
                </th>
                <th className='align-top' onClick={() => toggleSort('recover')}>
                  <span>Khôi phục</span>
                  {renderArrow('recover')}
                </th>
              </tr>
            </thead>
            <tbody>
              {page?.map((policyInfo, i) => (
                <tr key={`${policyInfo?.bankpolicyseq || ''}_${i}`}>
                  <td>{policyInfo?.policynum}</td>
                  <td>{convertUtcToLocalTime(policyInfo?.policyissuedt, 'DD-MM-YY')}</td>
                  <td>{policyInfo?.baseproductname}</td>
                  <td className='text-right'>{policyInfo?.premiumdueamount?.toLocaleString("en-US")}</td>
                  <td>{convertUtcToLocalTime(policyInfo?.premiumduedate, 'DD-MM-YY')}</td>
                  <td>{policyInfo?.poname}</td>
                  <td>{policyInfo?.pomobile}</td>
                  <td>{policyInfo?.poemail}</td>
                  <td>{policyInfo?.poidentifynum}</td>
                  <td>{policyInfo?.reinstatement}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={10}>{renderPaging()}</td>
              </tr>
            </tfoot>
          </table>
        </Form>
      )}
    </Formik>
  );
  return <div className='report__data'>{length > 0 ? renderTable() : null}</div>;
};

const mapStateToProps = (state) => {
  return {
    values: state?.policy?.data || [],
    loading: state?.policy?.loading,
  };
};

const mapDispatchToProps = { onMount: searchPolicy };

export default connect(mapStateToProps, mapDispatchToProps)(ReportPolicyListData);
